;(function() {
  'use strict'

  angular.module('core.cursor').directive('cursor', cursor)

  // --------------------

  /* @ngInject */
  function cursor() {
    return {
      restrict: 'A',
      link: link,
    }

    // -----

    function link(scope, elem, attrs) {
      var myName = attrs.cursor

      scope.$on('cursor:focus', onFocusEvent)
      scope.$on('cursor:blur', onBlurEvent)

      // ----

      function onFocusEvent(e, name) {
        if (myName === name) {
          elem[0].focus()
        }
      }

      function onBlurEvent(e, name) {
        if (myName === name) {
          elem[0].blur()
        }
      }
    }
  }
})()
